<template>
    <div>
        <slot>
            <template v-if="$isIOS">
                <h3>Subscription Required</h3>

                Manage your account and more at
                <a href="https://scorsync.com/more" @click.prevent="openIOSLink('https://scorsync.com/more')">
                    scorsync.com/more
                </a>
            </template>
            <template v-else>
                <h3>Activate your subscription for full access.</h3>
                <inertia-link href="/subscription/create">Start today!</inertia-link>
            </template>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'SubscriptionRequired',
};
</script>
